import { api } from './api'

/**
 * The contact form's two calls (backend-nest `contact_otpRequest` and
 * `contact_send`). Public — a visitor has no account. The message is only
 * sent from a phone the visitor proved they hold: a code is texted first,
 * and travels back with the message. `contact_send` resolves only once the
 * server says Telegram accepted it; every other outcome rejects, and the
 * page decides what to tell the visitor (see `contactFailureKind` in
 * lib/site.js).
 *
 * `website` is the honeypot: the page renders it hidden and sends it back
 * untouched, so a bot that filled it is dropped server-side (and, on the
 * code request, no SMS is spent).
 */
export async function requestContactCode(phone, website) {
  const { data } = await api.post('/contact/otp-request', { phone, website: website || undefined })
  return data
}

/**
 * The signed-in learner's own message (`contact_sendMine`, bearer). The
 * account's phone is already verified, so there is no code and no honeypot;
 * the server answers on that phone. Same resolve/reject contract as
 * `sendContact`.
 */
export async function sendMyContact({ email, subject, message }) {
  const { data } = await api.post('/contact/send-mine', {
    email: email.trim() || undefined,
    subject,
    message: message.trim(),
  })
  return data
}

export async function sendContact({ name, email, phone, code, subject, message, website }) {
  const { data } = await api.post('/contact/send', {
    name: name.trim() || undefined,
    email: email.trim() || undefined,
    phone,
    code,
    subject,
    message: message.trim(),
    website: website || undefined,
  })
  return data
}
